# Generated by https://pagedraw.io/pages/1470
React = require 'react'
createReactClass = require 'create-react-class'
Topbarbutton = require './topbarbutton'
Textbutton = require './textbutton'


module.exports = Topbar = createReactClass {
    displayName: 'Topbar'
    render: ->
        React.createElement("div", {"className": "topbar"},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              .topbar {
                  display: flex;
                  flex-grow: 1;
              }
              
              .topbar-stress-tester-0 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-right: 7px;
              }
              
              .topbar-0-0-0-0 {
                  height: 0px;
                  flex-grow: 0.32142857142857145;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-3 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 79px;
              }
              
              .topbar-0-0-0-2 {
                  height: 0px;
                  flex-grow: 0.2360248447204969;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-1 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton-7 {
                  flex-shrink: 0;
                  margin-left: 8px;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-0-0-0-5 {
                  height: 0px;
                  flex-grow: 0.23136645962732919;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-77 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton-4 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-0-0-0-8 {
                  height: 0px;
                  flex-grow: 0.2111801242236025;
                  flex-basis: 0px;
              }
              
              .topbar-0-0-0-9 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 7px;
                  padding-bottom: 7px;
              }
              
              .topbar-0-0-0-9-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-0-0-0-9-0-0 {
                  display: flex;
                  width: 94px;
                  height: 44px;
              }
              
              .topbar-rectangle_3 {
                  display: flex;
                  flex-direction: column;
                  cursor: pointer;
                  flex-grow: 1;
              }
              
              .topbar-0-0-0-9-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 30px;
                  padding-right: 33px;
              }
              
              .topbar-oval-3 {
                  width: 31px;
                  height: 31px;
                  flex-shrink: 0;
                  border-radius: 100%;
                  background: rgb(234, 195, 52);
              }
              
              .topbar-0-0-0-9-0-0-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 3px;
              }
              
              .topbar-text-8 {
                  width: 94px;
                  flex-shrink: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(66, 66, 66);
                  font-size: 8px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .topbar-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_2 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-tutorial-4 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 15px;
                  padding-right: 17px;
              }
              
              .topbar-topbarbutton_instance_1 {
                  width: 76px;
                  height: 58px;
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-1-0-0-1 {
                  height: 0px;
                  flex-grow: 1;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_3 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance-9 {
                  flex-shrink: 0;
                  margin-left: 2px;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-1-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_24 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-stackblitz-default-5 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-2-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 15px;
                  padding-right: 16px;
              }
              
              .topbar-topbarbutton_instance_13 {
                  width: 76px;
                  height: 58px;
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-2-0-0-1 {
                  height: 0px;
                  flex-grow: 0.20056497175141244;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_2 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance_4 {
                  flex-shrink: 0;
                  margin-left: 36px;
                  display: flex;
                  flex-direction: column;
                  min-width: 100px;
              }
              
              .topbar-2-0-0-4 {
                  height: 0px;
                  flex-grow: 0.3248587570621469;
                  flex-basis: 0px;
              }
              
              .topbar-rectangle_9 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 5px;
                  padding-bottom: 9px;
              }
              
              .topbar-2-0-0-5-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-text_4 {
                  width: 292px;
                  flex-shrink: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(97, 97, 97);
                  font-size: 24px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .topbar-2-0-0-5-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_8 {
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-2-0-0-5-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-2-0-0-5-1-0-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .topbar-text_4-0 {
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(82, 82, 185);
                  font-size: 13px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.59375px;
                  flex-grow: 1;
              }
              
              .topbar-text_4-6 {
                  flex-shrink: 0;
                  margin-left: 4px;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(95, 95, 95);
                  font-size: 13px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.4375px;
              }
              
              .topbar-2-0-0-5-1-0-0-2 {
                  flex-shrink: 0;
                  margin-left: 3px;
                  display: flex;
              }
              
              .topbar-text_4-5 {
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(82, 82, 185);
                  font-size: 13px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.015625px;
                  flex-grow: 1;
              }
              
              .topbar-2-0-0-6 {
                  height: 0px;
                  flex-grow: 0.4745762711864407;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_3-3 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance-0 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-2-0-0-9 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 28px;
                  padding-top: 9px;
                  padding-bottom: 9px;
              }
              
              .topbar-2-0-0-9-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-textbutton_instance-8 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 126px;
              }
              
              .topbar-2-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_24-3 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-default-7 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-3-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 15px;
                  padding-right: 4px;
              }
              
              .topbar-topbarbutton_instance_13-6 {
                  width: 76px;
                  height: 58px;
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-3-0-0-1 {
                  height: 0px;
                  flex-grow: 0.11784511784511785;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_13-8 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-3-0-0-3 {
                  height: 0px;
                  flex-grow: 0.11784511784511785;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_15 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 100px;
              }
              
              .topbar-topbarbutton_instance_16 {
                  flex-shrink: 0;
                  margin-left: 8px;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-3-0-0-6 {
                  height: 0px;
                  flex-grow: 0.3333333333333333;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_11 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-3-0-0-8 {
                  height: 0px;
                  flex-grow: 0.23905723905723905;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_14 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance_12 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-3-0-0-11 {
                  height: 0px;
                  flex-grow: 0.1919191919191919;
                  flex-basis: 0px;
              }
              
              .topbar-3-0-0-12 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 7px;
                  padding-bottom: 7px;
              }
              
              .topbar-3-0-0-12-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-3-0-0-12-0-0 {
                  display: flex;
                  width: 94px;
                  height: 44px;
              }
              
              .topbar-rectangle_3-1 {
                  display: flex;
                  flex-direction: column;
                  cursor: pointer;
                  flex-grow: 1;
              }
              
              .topbar-3-0-0-12-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 30px;
                  padding-right: 33px;
              }
              
              .topbar-oval-7 {
                  width: 31px;
                  height: 31px;
                  flex-shrink: 0;
                  border-radius: 100%;
                  background: rgb(234, 195, 52);
              }
              
              .topbar-3-0-0-12-0-0-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 3px;
              }
              
              .topbar-text-89 {
                  width: 94px;
                  flex-shrink: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(66, 66, 66);
                  font-size: 8px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .topbar-3-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_24-1 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-merge-conflict-8 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-4-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  justify-content: center;
              }
              
              .topbar-rectangle_1 {
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-4-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-topbarbutton_instance_7 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance_7-4 {
                  flex-shrink: 0;
                  margin-left: 5px;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton_instance_7-8 {
                  flex-shrink: 0;
                  margin-left: 4px;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-4-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_24-9 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-with-mk-multi-9 {
                  display: flex;
                  flex-direction: column;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-5-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 15px;
                  padding-right: 4px;
              }
              
              .topbar-topbarbutton_instance_13-82 {
                  width: 76px;
                  height: 58px;
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
              }
              
              .topbar-5-0-0-1 {
                  height: 0px;
                  flex-grow: 0.14143426294820718;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-49 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-5-0-0-3 {
                  height: 0px;
                  flex-grow: 0.13745019920318724;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-32 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 100px;
              }
              
              .topbar-5-0-0-5 {
                  height: 0px;
                  flex-grow: 0;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_9 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 100px;
              }
              
              .topbar-topbarbutton-2 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-5-0-0-8 {
                  height: 0px;
                  flex-grow: 0.21115537848605578;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton_instance_11-4 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-5-0-0-10 {
                  height: 0px;
                  flex-grow: 0.28286852589641437;
                  flex-basis: 0px;
              }
              
              .topbar-topbarbutton-15 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-topbarbutton-6 {
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  min-width: 76px;
              }
              
              .topbar-5-0-0-13 {
                  height: 0px;
                  flex-grow: 0.22709163346613545;
                  flex-basis: 0px;
              }
              
              .topbar-5-0-0-14 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 7px;
                  padding-bottom: 7px;
              }
              
              .topbar-5-0-0-14-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-5-0-0-14-0-0 {
                  display: flex;
                  width: 94px;
                  height: 44px;
              }
              
              .topbar-rectangle_3-7 {
                  display: flex;
                  flex-direction: column;
                  cursor: pointer;
                  flex-grow: 1;
              }
              
              .topbar-5-0-0-14-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 30px;
                  padding-right: 33px;
              }
              
              .topbar-oval-6 {
                  width: 31px;
                  height: 31px;
                  flex-shrink: 0;
                  border-radius: 100%;
                  background: rgb(234, 195, 52);
              }
              
              .topbar-5-0-0-14-0-0-0-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 3px;
              }
              
              .topbar-text-2 {
                  width: 94px;
                  flex-shrink: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(66, 66, 66);
                  font-size: 8px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .topbar-5-0-1 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-rectangle_24-4 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              .topbar-diff-viewer-9 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 15px;
                  background: linear-gradient(180deg, rgb(226, 226, 226), rgb(215, 213, 215));
                  flex-grow: 1;
              }
              
              .topbar-6-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .topbar-6-0-0-0 {
                  height: 0px;
                  flex-grow: 0.49948927477017363;
                  flex-basis: 0px;
              }
              
              .topbar-text_4-2 {
                  width: 292px;
                  flex-shrink: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica', sans-serif;
                  color: rgb(97, 97, 97);
                  font-size: 24px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
              }
              
              .topbar-6-0-0-2 {
                  height: 0px;
                  flex-grow: 0.5005107252298263;
                  flex-basis: 0px;
              }
              
              .topbar-6-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 15px;
              }
              
              .topbar-rectangle_24-34 {
                  height: 1px;
                  flex-grow: 1;
                  flex-basis: 0px;
                  background: rgb(167, 165, 165);
              }
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          ( if ((@props.whichTopbar) == "stress-tester")
              React.createElement("div", {"className": "topbar-stress-tester-0"},
                  React.createElement("div", {"className": "topbar-0-0-0"},
                      React.createElement("div", {"className": "topbar-0-0-0-0"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-3"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Infer constraints"), "onClick": ((@props.editor.inferConstraints)), "image": ("https://complex-houses.surge.sh/c393cf1c-56f7-4885-9c84-b0f892be754e/wildcard4.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-0-0-0-2"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-1"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Random Size"), "onClick": ((@props.editor.randomizeSize)), "image": ("https://complex-houses.surge.sh/1d46e25f-2b59-47c9-8f1d-9b6de444386a/simple-gear.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton-7"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Random Data"), "onClick": ((@props.editor.randomizeData)), "image": ("https://complex-houses.surge.sh/5be2f265-ef52-4864-ba86-077238bc2890/wildcard6.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-0-0-0-5"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-77"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom In"), "onClick": ((@props.editor.viewportManager.handleZoomIn)), "image": ("https://complex-houses.surge.sh/9a3fa941-ba37-4bcf-b071-6e4ff0e5a66d/zoom-plus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton-4"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom Out"), "onClick": ((@props.editor.viewportManager.handleZoomOut)), "image": ("https://complex-houses.surge.sh/4b48a72f-40e4-4110-a90f-15319b22814f/zoom-minus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-0-0-0-8"}),  
                      React.createElement("div", {"className": "topbar-0-0-0-9"},
                          React.createElement("div", {"className": "topbar-0-0-0-9-0"},
                              React.createElement("div", {"className": "topbar-0-0-0-9-0-0"},
                                  ( if (@props.editor.hasUncommitedChanges())
                                      React.createElement("div", {"onClick": (@props.editor.showCommitView), "className": "topbar-rectangle_3"},
                                          React.createElement("div", {"className": "topbar-0-0-0-9-0-0-0-0-0"},
                                              React.createElement("div", {"className": "topbar-oval-3"}) 
                                          ),
                                          React.createElement("div", {"className": "topbar-0-0-0-9-0-0-0-0-1"},
                                              React.createElement("div", {"className": "topbar-text-8"}, "Uncommited Changes")
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "topbar-0-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_2"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "tutorial")
              React.createElement("div", {"className": "topbar-tutorial-4"},
                  React.createElement("div", {"className": "topbar-1-0-0"},
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_1"},
                          (@props.editor.topbarBlockAdder())
                      ),
                      React.createElement("div", {"className": "topbar-1-0-0-1"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_3"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom In"), "onClick": ((@props.editor.viewportManager.handleZoomIn)), "image": ("https://complex-houses.surge.sh/9a3fa941-ba37-4bcf-b071-6e4ff0e5a66d/zoom-plus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton_instance-9"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom Out"), "onClick": ((@props.editor.viewportManager.handleZoomOut)), "image": ("https://complex-houses.surge.sh/4b48a72f-40e4-4110-a90f-15319b22814f/zoom-minus.png"), "disabled": (false)}) 
                      )
                  ),
                  React.createElement("div", {"className": "topbar-1-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "stackblitz-default")
              React.createElement("div", {"className": "topbar-stackblitz-default-5"},
                  React.createElement("div", {"className": "topbar-2-0-0"},
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_13"},
                          (@props.editor.topbarBlockAdder())
                      ),
                      React.createElement("div", {"className": "topbar-2-0-0-1"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_2"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Shortcuts"), "onClick": ((@props.editor.handleShortcuts)), "image": ("https://complex-houses.surge.sh/646bf1f4-d2b8-4697-ba79-6a40b45dd223/icons2 copy 4.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_4"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Make Reusable"), "onClick": ((@props.editor.handleNewComponent)), "image": ("https://complex-houses.surge.sh/1d46e25f-2b59-47c9-8f1d-9b6de444386a/simple-gear.png"), "disabled": ((@props.editor.getSelectedBlocks().length == 0))}) 
                      ),
                      React.createElement("div", {"className": "topbar-2-0-0-4"}),  
                      React.createElement("div", {"className": "topbar-rectangle_9"},
                          React.createElement("div", {"className": "topbar-2-0-0-5-0"},
                              React.createElement("div", {"className": "topbar-text_4"}, "Pagedraw Demo")
                          ),
                          React.createElement("div", {"className": "topbar-2-0-0-5-1"},
                              React.createElement("div", {"className": "topbar-rectangle_8"},
                                  React.createElement("div", {"className": "topbar-2-0-0-5-1-0-0"},
                                      React.createElement("a", {"href": "https://documentation.pagedraw.io/the-editor/", "target": "_blank", "className": "topbar-2-0-0-5-1-0-0-0"},
                                          React.createElement("div", {"className": "topbar-text_4-0"}, "Documentation")
                                      ),
                                      React.createElement("div", {"className": "topbar-text_4-6"}, ("•")),
                                      React.createElement("a", {"href": "https://documentation.pagedraw.io/install_existing/", "className": "topbar-2-0-0-5-1-0-0-2"},
                                          React.createElement("div", {"className": "topbar-text_4-5"}, """
                                              Install in an existing codebase
""")
                                      )
                                  )
                              )
                          )
                      ),
                      React.createElement("div", {"className": "topbar-2-0-0-6"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_3-3"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom In"), "onClick": ((@props.editor.viewportManager.handleZoomIn)), "image": ("https://complex-houses.surge.sh/9a3fa941-ba37-4bcf-b071-6e4ff0e5a66d/zoom-plus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton_instance-0"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom Out"), "onClick": ((@props.editor.viewportManager.handleZoomOut)), "image": ("https://complex-houses.surge.sh/4b48a72f-40e4-4110-a90f-15319b22814f/zoom-minus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-2-0-0-9"},
                          React.createElement("div", {"className": "topbar-2-0-0-9-0"},
                              React.createElement("div", {"className": "topbar-textbutton_instance-8"},
                                  React.createElement(Textbutton, {"text": ("SHARE"), "onClick": ((@props.editor.handleStackBlitzSave)), "disabled": (false)}) 
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "topbar-2-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24-3"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "default")
              React.createElement("div", {"className": "topbar-default-7"},
                  React.createElement("div", {"className": "topbar-3-0-0"},
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_13-6"},
                          (@props.editor.topbarBlockAdder())
                      ),
                      React.createElement("div", {"className": "topbar-3-0-0-1"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_13-8"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Shortcuts"), "onClick": ((@props.editor.handleShortcuts)), "image": ("https://complex-houses.surge.sh/646bf1f4-d2b8-4697-ba79-6a40b45dd223/icons2 copy 4.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-3-0-0-3"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_15"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Make Reusable"), "onClick": ((@props.editor.handleNewComponent)), "image": ("https://complex-houses.surge.sh/1d46e25f-2b59-47c9-8f1d-9b6de444386a/simple-gear.png"), "disabled": ((@props.editor.getSelectedBlocks().length == 0))}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_16"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Sync Code"), "onClick": ((@props.editor.handleExport)), "image": ("https://complex-houses.surge.sh/54591ad3-7fea-4d20-aa86-f238ca03aeac/icons2 copy.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-3-0-0-6"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_11"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Preview"), "onClick": ((@props.editor.handlePlay)), "image": ("https://complex-houses.surge.sh/96f40588-00f2-453a-89b8-6df4287ab39a/play-button.svg"), "disabled": ((not @props.editor.topbarPlayButtonIsEnabled()))}) 
                      ),
                      React.createElement("div", {"className": "topbar-3-0-0-8"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_14"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom In"), "onClick": ((@props.editor.viewportManager.handleZoomIn)), "image": ("https://complex-houses.surge.sh/9a3fa941-ba37-4bcf-b071-6e4ff0e5a66d/zoom-plus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_12"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom Out"), "onClick": ((@props.editor.viewportManager.handleZoomOut)), "image": ("https://complex-houses.surge.sh/4b48a72f-40e4-4110-a90f-15319b22814f/zoom-minus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-3-0-0-11"}),  
                      React.createElement("div", {"className": "topbar-3-0-0-12"},
                          React.createElement("div", {"className": "topbar-3-0-0-12-0"},
                              React.createElement("div", {"className": "topbar-3-0-0-12-0-0"},
                                  ( if (@props.editor.hasUncommitedChanges())
                                      React.createElement("div", {"onClick": (@props.editor.showCommitView), "className": "topbar-rectangle_3-1"},
                                          React.createElement("div", {"className": "topbar-3-0-0-12-0-0-0-0-0"},
                                              React.createElement("div", {"className": "topbar-oval-7"}) 
                                          ),
                                          React.createElement("div", {"className": "topbar-3-0-0-12-0-0-0-0-1"},
                                              React.createElement("div", {"className": "topbar-text-89"}, "Uncommited Changes")
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "topbar-3-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24-1"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "merge-conflict")
              React.createElement("div", {"className": "topbar-merge-conflict-8"},
                  React.createElement("div", {"className": "topbar-4-0-0"},
                      React.createElement("div", {"className": "topbar-rectangle_1"},
                          React.createElement("div", {"className": "topbar-4-0-0-0-0"},
                              React.createElement("div", {"className": "topbar-topbarbutton_instance_7"},
                                  React.createElement(Topbarbutton, {"state": ("A"), "text": ("Choose Left"), "onClick": ((@props.editor.chooseLeft)), "image": ("https://complex-houses.surge.sh/368d9d5e-4107-4e76-b466-dde635be1a1a/118739.svg"), "disabled": (false)}) 
                              ),
                              React.createElement("div", {"className": "topbar-topbarbutton_instance_7-4"},
                                  React.createElement(Topbarbutton, {"state": ("A"), "text": ("Choose Right"), "onClick": ((@props.editor.chooseRight)), "image": ("https://complex-houses.surge.sh/a3ff854e-d14c-44c1-af63-5ef71235dbf1/126490.svg"), "disabled": (false)}) 
                              ),
                              React.createElement("div", {"className": "topbar-topbarbutton_instance_7-8"},
                                  React.createElement(Topbarbutton, {"state": ("A"), "text": ("Abort Merge"), "onClick": ((@props.editor.abort)), "image": ("https://complex-houses.surge.sh/5b0f0c48-acdc-40bf-a287-e81b4eb37520/cancel-512.png"), "disabled": (false)}) 
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "topbar-4-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24-9"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "with-mk-multi")
              React.createElement("div", {"className": "topbar-with-mk-multi-9"},
                  React.createElement("div", {"className": "topbar-5-0-0"},
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_13-82"},
                          (@props.editor.topbarBlockAdder())
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-1"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-49"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Shortcuts"), "onClick": ((@props.editor.handleShortcuts)), "image": ("https://complex-houses.surge.sh/646bf1f4-d2b8-4697-ba79-6a40b45dd223/icons2 copy 4.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-3"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-32"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Make Reusable"), "onClick": ((@props.editor.handleNewComponent)), "image": ("https://complex-houses.surge.sh/1d46e25f-2b59-47c9-8f1d-9b6de444386a/simple-gear.png"), "disabled": ((@props.editor.getSelectedBlocks().length == 0))}) 
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-5"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_9"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Make Multistate"), "onClick": ((@props.editor.handleMakeMultistate)), "image": ("https://complex-houses.surge.sh/874818bf-3f3b-4928-835b-061218fc26bf/wildcard3.png"), "disabled": ((@props.editor.getSelectedBlocks().length == 0))}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton-2"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Sync Code"), "onClick": ((@props.editor.handleExport)), "image": ("https://complex-houses.surge.sh/54591ad3-7fea-4d20-aa86-f238ca03aeac/icons2 copy.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-8"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton_instance_11-4"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Preview"), "onClick": ((@props.editor.handlePlay)), "image": ("https://complex-houses.surge.sh/96f40588-00f2-453a-89b8-6df4287ab39a/play-button.svg"), "disabled": ((not @props.editor.topbarPlayButtonIsEnabled()))}) 
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-10"}),  
                      React.createElement("div", {"className": "topbar-topbarbutton-15"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom In"), "onClick": ((@props.editor.viewportManager.handleZoomIn)), "image": ("https://complex-houses.surge.sh/9a3fa941-ba37-4bcf-b071-6e4ff0e5a66d/zoom-plus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-topbarbutton-6"},
                          React.createElement(Topbarbutton, {"state": ("A"), "text": ("Zoom Out"), "onClick": ((@props.editor.viewportManager.handleZoomOut)), "image": ("https://complex-houses.surge.sh/4b48a72f-40e4-4110-a90f-15319b22814f/zoom-minus.png"), "disabled": (false)}) 
                      ),
                      React.createElement("div", {"className": "topbar-5-0-0-13"}),  
                      React.createElement("div", {"className": "topbar-5-0-0-14"},
                          React.createElement("div", {"className": "topbar-5-0-0-14-0"},
                              React.createElement("div", {"className": "topbar-5-0-0-14-0-0"},
                                  ( if (@props.editor.hasUncommitedChanges())
                                      React.createElement("div", {"onClick": (@props.editor.showCommitView), "className": "topbar-rectangle_3-7"},
                                          React.createElement("div", {"className": "topbar-5-0-0-14-0-0-0-0-0"},
                                              React.createElement("div", {"className": "topbar-oval-6"}) 
                                          ),
                                          React.createElement("div", {"className": "topbar-5-0-0-14-0-0-0-0-1"},
                                              React.createElement("div", {"className": "topbar-text-2"}, "Uncommited Changes")
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "topbar-5-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24-4"}) 
                  )
              )
          ),
          ( if ((@props.whichTopbar) == "diff-viewer")
              React.createElement("div", {"className": "topbar-diff-viewer-9"},
                  React.createElement("div", {"className": "topbar-6-0-0"},
                      React.createElement("div", {"className": "topbar-6-0-0-0"}),  
                      React.createElement("div", {"className": "topbar-text_4-2"}, "Diff Mode"),
                      React.createElement("div", {"className": "topbar-6-0-0-2"}) 
                  ),
                  React.createElement("div", {"className": "topbar-6-0-1"},
                      React.createElement("div", {"className": "topbar-rectangle_24-34"}) 
                  )
              )
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/topbar.cjsx